import { uploadUrl } from "@/common/js/config";
import Axios from "axios";
import qs from "qs";
import router from '@/router'
import Vue from 'vue'

Axios.interceptors.request.use(
  config => {
    config.data = qs.stringify(config.data);
    return config;
  },
  err => {
    console.log(err);
  }
);

export const getUploadToken = (fn, type = 1) => {
  Axios.post(uploadUrl + "/qiniu/getUploadTokenAndFileName", {
    type
  }).then(data => {
    fn(data.data.data);
  });
  // let data = instance.post(uploadUrl + '/qiniu/getUploadToken', {type})
};

export const catchCode = (status, message) => {
  switch (status) {
    case 413:
      router.replace({ name: 'login' })
      break
    default:
      Vue.prototype.$Notice.error({
        title: '请求错误',
        desc: message,
        duration: 3
      })
      break
  }
}

export const catchError = function (error) {
  if (error.response) {
    switch (error.response.status) {
      case 400:
        Vue.prototype.$Notice.error({
          title: '请求参数异常',
          duration: 3
        })
        break
      case 403:
        Vue.prototype.$Notice.error({
          title: '服务器拒绝您的请求',
          duration: 3
        })
        break
      case 404:
        Vue.prototype.$Notice.error({
          title: '请求的资源未找到',
          duration: 3
        })
        break
      default:
        Vue.prototype.$Notice.error({
          title: '请求失败，请联系技术人员',
          duration: 3
        })
    }
  }
  return Promise.reject(error)
}